import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getAllNivFor() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-all-NivFor`);
    return response

  } catch (error) {
    console.error('Error al obtener los niveles de formación', error);
  }
}